module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei7.svg";